<script lang="ts">
  export let value: string = null;
  export let id: string = null;
  export let name: string = null;
  export let placeholder: string = null;
  export let error: string = null;
  export let required: boolean = false;
</script>

<input bind:value {id} {name} {placeholder} {required} type="text" />

{#if !!error}
  <p>{error}</p>
{/if}

<style lang="scss">
  @import "src/lib/styles/variables.scss";

  input {
    height: 3rem;
    border-radius: 0.25rem;
    border: 2px solid $color-disabled;
    padding: 0 1rem;
    width: -webkit-fill-available;
    width: -moz-available;

    &:focus {
      border: 2px solid $color-primary;
      outline: none;
    }
  }

  p {
    margin: 0.125rem 0;
    padding: 0 0.9375rem;
    color: #c4241d;
    font-size: 0.8125rem;
    line-height: 1.4;
    font-family: Roboto;
  }
</style>
